import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators, Dispatch } from "redux";
import { v4 as uuidv4 } from "uuid";
import {
  AppNotifications,
  BlogStatus,
  FORM_MODE,
  LanguageOutputModel,
  RootState,
  SolutionInputModel,
  SolutionOutputModel,
  TCb,
  UploadedImageModel,
} from "../../../../../models";
import { TechnologyService } from "../../../../../services/technology.service";
import { AllLanguageListActions, NotificationActions } from "../../../../../store/actions";
import { ImageUtil, loadCallback } from "../../../../../utils";
import TechnologyFormPresenter from "./TechnologyForm.presenter";
import { C_Props, C_States, MapDispatchToProps, MapStateToProps, MergedProps } from "./TechnologyForm.type";

class TechnologyFormContainer extends Component<MergedProps, C_States> {
  constructor(props) {
    super(props);

    this.state = {
      mode: FORM_MODE.CREATE,
      loading: false,
      initData: null,

      solutionStatus: {
        status: false,
        timePublication: null,
        isPublish: false,
      },

      solutionContent: {},
      newSolutionContent: null,

      solutionPictures: [],
      languageData: this.props.all_language_list.data,
      activeLanguageId: this.props.all_language_list.data.find((e: LanguageOutputModel) => e.isPrimary)?.id,
      filter: {
        code: "",
      },
      bannerImage: "",
      solutionDetail: null,
    };
  }

  onChangeLanguage = (languageId: string) => {
    this.setState({
      activeLanguageId: languageId,
    });
  };

  onUploadBanner = (data: UploadedImageModel) => {
    const formData = new FormData();
    formData.append("image", data.file);
    TechnologyService.uploadImageTechnologyPage(formData)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.setState({
            solutionPictures: [
              { id: uuidv4(), src: ImageUtil.buildTechnologyImgSrc(res.data.data)!, alt: data.alt || "" },
            ],
          });
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Upload image failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Upload image failed" });
      });
  };

  onRemoveBanner = (fileId: string) => {
    const banners = this.state.solutionPictures.filter((p) => p.id !== fileId);
    this.setState({
      solutionPictures: banners,
    });
  };

  onChangeSolutionStatus = (status: boolean) => {
    this.setState((prevState) => {
      return {
        solutionStatus: {
          ...prevState.solutionStatus,
          status,
        },
      };
    });
  };

  onChangeShowPublishTime = (isPublish: boolean) => {
    this.setState((prevState) => {
      return {
        solutionStatus: {
          ...prevState.solutionStatus,
          isPublish,
        },
      };
    });
  };

  onChangeTimePublication = (date: string | null) => {
    this.setState((prevState) => {
      return {
        solutionStatus: {
          ...prevState.solutionStatus,
          timePublication: date,
        },
      };
    });
  };

  onUploadContentImgHandler() {
    const self = this as any;
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      const file = input.files![0];
      const formData = new FormData();

      formData.append("image", file);
      // Save current cursor state
      const range = self.quill.getSelection(true);
      // Insert temporary loading placeholder image
      // quill.insertEmbed(range.index, "image", `${window.location.origin}/images/loaders/placeholder.gif`);

      // Move cursor to right side of image (easier to continue typing)
      self.quill.setSelection(range.index + 1, 1);

      const res = await TechnologyService.uploadImageTechnologyPage(formData);

      // Remove placeholder image
      // quill.deleteText(range.index, 1);

      if (res && res.status === 201) {
        self.quill.insertEmbed(range.index, "image", ImageUtil.buildSolutionImgSrc(res.data.data));
      }
    };
  }

  onChangeSolutionContent = (val: any, langId: string) => {
    this.setState((prev) => {
      return {
        solutionContent: {
          ...prev.solutionContent,
          [langId]: val,
        },
      };
    });
  };

  onSubmit = (val: any) => {
    if (!this.state.solutionPictures.length) {
      this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Please upload an image" });
      return;
    }

    if (!this.state.solutionContent) {
      this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Please input content" });
      return;
    }

    const banner = this.state.solutionPictures[0];

    let data: SolutionInputModel[] = [];
    console.log(val);

    this.state.languageData.forEach((lang) => {
      if (val[`title${lang.id}`]) {
        let dataObj: any = {
          title: val[`title${lang.id}`],
          bannerImage: ImageUtil.convertImgServerSrc(banner.src, "solution"),
          status: this.state.solutionStatus.status ? BlogStatus.PUBLISH : BlogStatus.UNPUBLISH,
          publishDate: this.state.solutionStatus.timePublication,
          isPublish: this.state.solutionStatus.isPublish,
          description: this.state.solutionContent[lang.id],
          shortDescription: val[`shortDescription${lang.id}`],
          categoryId: val[`categoryId${lang.id}`],
          languageId: lang.id,
        };
        // dataObj = _.pickBy(dataObj, (v) => !_.isUndefined(v));
        const found = this.state.initData?.find((i) => i.languageId === lang.id) || false;
        this.state.mode !== FORM_MODE.CREATE &&
          found &&
          Object.assign(dataObj, {
            id: this.state.initData?.find((i) => i.languageId === lang.id)?.id,
          });
        data.push(dataObj);
      }
    });

    if (this.state.mode === FORM_MODE.CREATE) {
      this.onCreateSolution(data);
    } else {
      this.onUpdateSolution(data);
    }
  };

  onLoadAllSolutionDetail = (technologyPageCode: string, cb?: TCb) => {
    this.setState({ loading: true, initData: null }, () => {
      TechnologyService.getTechnologyPage(technologyPageCode)
        .then((res) => {
          if (res && (res.status === 200 || res.status === 201)) {
            const data: SolutionOutputModel[] = res.data.data;

            data.forEach((item) => {
              const banner = item.bannerImage
                ? {
                    id: item.id,
                    src: ImageUtil.buildSolutionImgSrc(item.bannerImage)!,
                    alt: item.bannerImage || "",
                  }
                : undefined;

              this.setState({
                solutionPictures: banner ? [banner] : [],
                solutionStatus: {
                  status: item.status === BlogStatus.PUBLISH,
                  timePublication: item.publishDate,
                  isPublish: item.isPublish,
                },
                // newSolutionContent: item.description,
              });
            });

            this.setState(
              {
                mode: FORM_MODE.EDIT,
                solutionDetail: data,
                initData: data,
                loading: false,
                solutionContent: data.reduce((res, item) => {
                  return {
                    ...res,
                    [item.languageId]: item.description,
                  };
                }, {}),
              },
              () => {
                loadCallback(cb?.success);
              },
            );
          } else {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.ERROR,
              message: "Load data failed",
            });
            this.props.history.goBack();
          }
        })
        .catch((err) => {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Load data failed",
          });
        });
    });
  };

  onCreateSolution = (data) => {
    TechnologyService.createTechnologyPage(data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Create post success",
          });
          loadCallback(this.props.onComplete_Create);
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create post failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create post failed" });
      });
  };

  onUpdateSolution = (data) => {
    TechnologyService.updateTechnologyPage(this.props.solutionPageCode!, data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Update post success",
          });
          loadCallback(this.props.onComplete_Update);
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Update post failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Update post failed" });
      });
  };

  componentDidMount = () => {
    if (this.props.solutionPageCode) {
      // this.onLoadSolutionDetail(this.props.solutionPageCode);
      this.onLoadAllSolutionDetail(this.props.solutionPageCode);
    }
  };

  render() {
    return (
      <TechnologyFormPresenter
        {...this.props}
        {...this.state}
        onUploadBanner={this.onUploadBanner}
        onRemoveBanner={this.onRemoveBanner}
        onChangeLanguage={this.onChangeLanguage}
        onChangeSolutionStatus={this.onChangeSolutionStatus}
        onChangeTimePublication={this.onChangeTimePublication}
        onChangeShowPublishTime={this.onChangeShowPublishTime}
        onUploadContentImgHandler={this.onUploadContentImgHandler}
        onChangeSolutionContent={this.onChangeSolutionContent}
        onSubmit={this.onSubmit}
      />
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({
      all_language_list: state.all_language_list,
    }),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions, AllLanguageListActions), dispatch),
    }),
  )(TechnologyFormContainer),
);
